import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import Loader from "../../components/Loader";
import emptyStateImage from "../../images/dashboard/empty-state.png";
import EngagementTable from "./AllClientsTable";
import OverviewDataCards from './OverviewDataCards';
import TotalIcon from "../../images/dashboard/icon-total.png";
import CompleteIcon from "../../images/dashboard/icon-completed.png";
import AuditIcon from "../../images/dashboard/icon-audits.png";
import AddClientModal from "./AddClientModal";
import iconAdd from "../../images/Icons-add.png";
import { useNavigate } from "react-router-dom";
import './index.scss';

// Dummy clients data
const dummyClients = [
  { id: 1, name: "Urban Estates Works" },
  { id: 2, name: "VistaEdge Solutions" },
  { id: 3, name: "SilverSprout Co" },
  { id: 4, name: "GreenHaven Ventures" },
  { id: 5, name: "BoldPeak Studios" }
];

function ClientManagement() {
  const [loading, setLoading] = useState(true);
  const [clients, setClients] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const [counts, setCounts] = useState({
    totalClients: 0,
    activeEngagements: 0,
    upcomingYearEnds: 0,
  });

  const [isChecked, setIsChecked] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState(null);

  useEffect(() => {
    // Simulate API call with dummy data
    setTimeout(() => {
      setClients(dummyClients);
      setLoading(false);
    }, 1000);
  }, [isModalOpen]);

  const handleEditClick = (clientId) => {
    setSelectedClientId(clientId);
    navigate(`/edit-client/${clientId}`, { state: { clientId: clientId } });
  }

  const handleAction = () => {
    setIsModalOpen(true);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleToggle = (value) => {
    setIsChecked(value);
  };

  const overviewDetails = [
    { label: "Total Clients", value: counts.totalClients, icon: TotalIcon },
    { label: "Active Engagements", value: counts.activeEngagements, icon: CompleteIcon },
    { label: "Upcoming Year Ends", value: counts.upcomingYearEnds, icon: AuditIcon },
  ];


  return (
    loading ? (<Loader />) : (
      <>
        <Card className="px-3 py-4 mb-4 client-header" style={{ border: '1px solid #ECEEF5' }}>
          <Row>
            <Col className="my-auto">
              <h3 className="fw-bold mb-0" style={{ fontSize: '20px' }}>All Clients</h3>
            </Col>
            <Col className="my-auto mt-md-0 d-flex justify-content-end">

              <Button
                variant="primary"
                size="md"
                className="px-4 fw-bold"
                onClick={handleAction}
              >
                <img src={iconAdd} alt="add" className="me-2 my-auto" />
                Add New Client
              </Button>

            </Col>
          </Row>
        </Card>

        <Container fluid className="my-4 ">
          <Row className="mb-4">
            {overviewDetails.map((item, index) => (
              <Col md={6} lg={6} xl={4} key={index}>
                <Card className="p-3 h-100" style={{ border: '2px solid #ECEEF5' }}>
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center me-3"
                      style={{ width: '48px', height: '48px', backgroundColor: '#F0F5FF' }}
                    >
                      <img src={item.icon} alt={item.label} width={50} />
                    </div>
                    <div>
                      <h5 className="fw-bold text-dark my-auto" style={{ fontSize: '40px' }}>{item.value}</h5>
                      <p className="mb-0" style={{ fontSize: '18px' }}>{item.label}</p>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>

          {clients.length === 0 ? (
            <Row className="justify-content-center text-center my-5">
              <Col md={12}>
                <Card className="shadow-sm border-0 py-5">
                  <Card.Body className="d-flex flex-column align-items-center">
                    <Image src={emptyStateImage} alt="No Data" className="img-fluid mb-4" style={{ maxHeight: '200px' }} />
                    <div style={{ backgroundColor: '#F6F6FB', maxWidth: '500px' }} className="p-4 rounded" >
                      <Card.Title className="text-dark fw-bold mb-3">Client Management</Card.Title>
                      <p className="text-muted mb-4">No clients available in the system. Start adding clients to manage your engagements.</p>
                      <Button variant="primary"
                        className="border-0 text-white px-4 py-2" onClick={handleAction}>
                        Add New Client
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col>
                <EngagementTable
                  isClientModalOpen={isModalOpen}
                  setCounts={setCounts}
                  isChecked={isChecked}
                  onEditClick={handleEditClick}
                />
              </Col>
            </Row>
          )}

          {/* {isModalOpen && ( */}
          <AddClientModal isOpen={isModalOpen} toggle={toggleModal} onToggle={handleToggle} />
          {/* )} */}
        </Container>
      </>
    )
  );
}

export default ClientManagement;